/**
 * Monthlees Magnus — composer draft capture + launch modal + embed open (PR-2).
 * Option A: talk-module opens the global drawer embed; navigation is no-JS fallback only.
 */
(function () {
  'use strict';

  var DRAFT_KEY = 'monthlees_guide_draft';
  var ENTERED_KEY = 'monthlees_guide_entered';
  var LAUNCH_SEEN_KEY = 'monthlees_guide_launch_seen';
  var PV_KEY = 'monthlees_guide_pv';
  var PV_TS_KEY = 'monthlees_guide_pv_first_ts';
  var APP_FALLBACK = 'https://guide.monthlees.com';

  function readDraft() {
    try {
      return sessionStorage.getItem(DRAFT_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function writeDraft(value) {
    try {
      sessionStorage.setItem(DRAFT_KEY, String(value || '').trim());
    } catch (e) {
      /* ignore */
    }
  }

  function markEntered() {
    try {
      localStorage.setItem(ENTERED_KEY, '1');
    } catch (e) {
      /* ignore */
    }
  }

  function hasEntered() {
    try {
      return localStorage.getItem(ENTERED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function pathIsMagnusPage(path) {
    path = (path || window.location.pathname || '').toLowerCase();
    return path.indexOf('/pages/magnus') === 0 || path.indexOf('/pages/guide') === 0;
  }

  function pathIsSuppressed() {
    var path = (window.location.pathname || '').toLowerCase();
    if (pathIsMagnusPage(path)) return true;
    if (path.indexOf('/checkout') === 0) return true;
    if (path.indexOf('/cart') === 0) return true;
    if (path.indexOf('/account/login') === 0) return true;
    if (path.indexOf('/customer_authentication') === 0) return true;
    if (path.indexOf('/pages/precision-assessment') === 0) return true;
    if (path.indexOf('/pages/precision-reveal') === 0) return true;
    return false;
  }

  function bumpPageview() {
    try {
      var n = parseInt(localStorage.getItem(PV_KEY) || '0', 10) || 0;
      n += 1;
      localStorage.setItem(PV_KEY, String(n));
      if (!localStorage.getItem(PV_TS_KEY)) {
        localStorage.setItem(PV_TS_KEY, String(Date.now()));
      }
      return n;
    } catch (e) {
      return 1;
    }
  }

  function isSelfMagnusUrl(url) {
    if (!url) return false;
    try {
      if (url.charAt(0) === '/') {
        return pathIsMagnusPage(url.split('?')[0]);
      }
      var u = new URL(url, window.location.origin);
      if (u.origin !== window.location.origin) return false;
      return pathIsMagnusPage(u.pathname);
    } catch (e) {
      return String(url).indexOf('/pages/magnus') !== -1 || String(url).indexOf('/pages/guide') !== -1;
    }
  }

  /** No-JS / hard fallback — never reload /pages/magnus onto itself. */
  function resolveFallbackUrl(preferred) {
    var url = preferred || '/pages/magnus';
    if (pathIsMagnusPage() && isSelfMagnusUrl(url)) {
      return APP_FALLBACK;
    }
    if (isSelfMagnusUrl(url) && pathIsMagnusPage()) {
      return APP_FALLBACK;
    }
    return url;
  }

  function navigateFallback(opts) {
    opts = opts || {};
    writeDraft(opts.draft || opts.message || '');
    if (window.MonthleesMagnusAgent && typeof window.MonthleesMagnusAgent.markPendingOpen === 'function') {
      window.MonthleesMagnusAgent.markPendingOpen();
    } else {
      try {
        sessionStorage.setItem('monthlees_guide_pending_open', '1');
      } catch (e) {
        /* ignore */
      }
    }
    window.location.href = resolveFallbackUrl(opts.fallbackUrl);
  }

  function openAgent(opts) {
    opts = opts || {};
    var openFn =
      (window.MonthleesMagnus && typeof window.MonthleesMagnus.open === 'function' && window.MonthleesMagnus.open) ||
      (window.MonthleesMagnusAgent &&
        typeof window.MonthleesMagnusAgent.open === 'function' &&
        window.MonthleesMagnusAgent.open);

    if (typeof openFn === 'function') {
      try {
        var result = openFn.call(window.MonthleesMagnus || window.MonthleesMagnusAgent, opts);
        if (result && typeof result.then === 'function') {
          return result.catch(function () {
            navigateFallback(opts);
          });
        }
        return Promise.resolve(result);
      } catch (e) {
        navigateFallback(opts);
        return Promise.resolve();
      }
    }

    navigateFallback(opts);
    return Promise.resolve();
  }

  function initComposer(root) {
    var form = root.querySelector('[data-mg-composer-form]');
    var input = root.querySelector('[data-mg-composer-input]');
    if (!form || !input) return;

    var mode = root.getAttribute('data-mg-composer-mode') || 'guide';
    var scope = root.getAttribute('data-mg-scope') || 'precision';
    var destAttr = root.getAttribute('data-mg-destination') || form.getAttribute('action') || '/pages/magnus';

    // Hard-stop self-submit: if we're already on Magnus and action points here, retarget the app.
    if (pathIsMagnusPage() && isSelfMagnusUrl(destAttr)) {
      form.setAttribute('action', APP_FALLBACK);
      root.setAttribute('data-mg-destination', APP_FALLBACK);
      destAttr = APP_FALLBACK;
    }

    var existing = readDraft();
    if (existing && !input.value) input.value = existing;

    function go(text) {
      var draft = String(text || '').trim();
      if (!draft) {
        input.focus();
        return;
      }
      writeDraft(draft);
      markEntered();

      // Homepage module: prefer in-page drawer when embed is available; else carry draft to /pages/magnus.
      if (mode === 'homepage') {
        if (window.MonthleesMagnus && typeof window.MonthleesMagnus.open === 'function') {
          openAgent({
            message: draft,
            draft: draft,
            scope: scope,
            surface: 'drawer',
            context: 'home',
            entry_surface: 'homepage_3b',
            fallbackUrl: resolveFallbackUrl(destAttr),
          });
          return;
        }
        if (window.MonthleesMagnusAgent && typeof window.MonthleesMagnusAgent.markPendingOpen === 'function') {
          window.MonthleesMagnusAgent.markPendingOpen();
        } else {
          try {
            sessionStorage.setItem('monthlees_guide_pending_open', '1');
          } catch (e) {
            /* ignore */
          }
        }
        window.location.href = resolveFallbackUrl('/pages/magnus');
        return;
      }

      // Landing hero + funnel: open the real Magnus drawer with the typed text seeded.
      openAgent({
        message: draft,
        draft: draft,
        scope: scope,
        surface: 'drawer',
        context: 'guide_page',
        entry_surface: 'guide_page',
        fallbackUrl: resolveFallbackUrl(destAttr),
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      go(input.value);
    });

    root.querySelectorAll('[data-mg-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var text = chip.getAttribute('data-mg-chip') || chip.textContent;
        input.value = text;
        go(text);
      });
    });

    var attach = root.querySelector('[data-mg-attach-labs]');
    if (attach) {
      attach.addEventListener('click', function () {
        var labsUrl = attach.getAttribute('data-mg-labs-url') || '/pages/precision-labs';
        writeDraft(input.value);
        window.location.href = labsUrl;
      });
    }
  }

  function initLaunchModal(root) {
    if (!root || pathIsSuppressed() || hasEntered()) return;
    try {
      if (localStorage.getItem(LAUNCH_SEEN_KEY) === '1') return;
    } catch (e) {
      return;
    }

    var pv = bumpPageview();
    var delayMs = parseInt(root.getAttribute('data-mg-launch-delay') || '20000', 10);
    var minPv = parseInt(root.getAttribute('data-mg-launch-min-pv') || '2', 10);
    if (pv < minPv) return;

    var card = root.querySelector('[data-mg-launch-card]');
    var scrim = root.querySelector('[data-mg-launch-scrim]');
    var lastFocus = null;

    function dismiss(permanent) {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('mg-launch-open');
      if (permanent !== false) {
        try {
          localStorage.setItem(LAUNCH_SEEN_KEY, '1');
        } catch (e) {
          /* ignore */
        }
      }
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function open() {
      if (hasEntered() || pathIsSuppressed()) return;
      try {
        if (localStorage.getItem(LAUNCH_SEEN_KEY) === '1') return;
      } catch (e) {
        return;
      }
      lastFocus = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mg-launch-open');
      var closeBtn = root.querySelector('[data-mg-launch-close]');
      if (closeBtn) closeBtn.focus();
      try {
        localStorage.setItem(LAUNCH_SEEN_KEY, '1');
      } catch (e) {
        /* ignore */
      }
    }

    root.querySelectorAll('[data-mg-launch-close], [data-mg-launch-dismiss]').forEach(function (el) {
      el.addEventListener('click', function () {
        dismiss(true);
      });
    });

    if (scrim) {
      scrim.addEventListener('click', function () {
        dismiss(true);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !root.hidden) {
        event.preventDefault();
        dismiss(true);
      }
    });

    var cta = root.querySelector('[data-mg-launch-cta]');
    if (cta) {
      cta.addEventListener('click', function (event) {
        event.preventDefault();
        markEntered();
        dismiss(true);
        openAgent({
          draft: readDraft(),
          message: readDraft(),
          scope: 'precision',
          surface: 'drawer',
          context: 'home',
          entry_surface: 'launch_modal',
          fallbackUrl: resolveFallbackUrl(cta.getAttribute('href') || '/pages/magnus'),
        });
      });
    }

    window.setTimeout(open, isNaN(delayMs) ? 20000 : delayMs);
    if (card) card.setAttribute('tabindex', '-1');
  }

  function init() {
    document.querySelectorAll('[data-mg-composer]').forEach(initComposer);
    var launch = document.querySelector('[data-mg-launch]');
    if (launch) initLaunchModal(launch);
  }

  window.MonthleesMagnus = Object.assign(window.MonthleesMagnus || {}, {
    readDraft: readDraft,
    writeDraft: writeDraft,
    markEntered: markEntered,
    openAgent: openAgent,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* COMPAT_ALIAS_MAGNUS */
  window.MonthleesGuide = window.MonthleesMagnus;
})();
